import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UserData } from 'src/app/components/layout/models/interface/userData.interface';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { LayoutMenuActions } from '../../layout.page.component.actions.enum';
import { UserDataService } from 'src/app/components/shared/sharedServices/user-data.service';
import { LayoutTopbarMenu } from 'src/app/components/layout/models/interface/layoutTopbarMenu.interface';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/components/shared/sharedModules/permission/permission.service';
import { PermissionProfileOption } from 'src/app/components/shared/sharedModules/permission/keys/permissionProfile.enum';
import { PermissionUserOption } from 'src/app/components/shared/sharedModules/permission/keys/permissionUser.interface';
import { ExpressMerchandiseFlags } from 'src/app/components/express-basic/pages/merchandise/express-merchandise.flags';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { LoginSharedActions } from 'src/app/components/shared/sharedModules/auth/login-shared/login-shared-actions';

@Component({
  selector: 'app-layout-page-menu-top-bar',
  templateUrl: './layout-page-menu-top-bar.component.html',
  styleUrls: ['./layout-page-menu-top-bar.component.sass'],
})
export class LayoutPageMenuTopBarComponent implements OnInit, OnDestroy {
  @Input() actionList: Actions<LayoutMenuActions, any>;
  @Input() accountTypeIcon: number;
  @Input() redirectLink: string;
  @ViewChild('topbarmenu') topbar: ElementRef;
  userData: UserData;
  actionListEnum = LayoutMenuActions;
  loginActionsMenu: Actions<LayoutMenuActions, any> = new Actions<LayoutMenuActions, any>();
  layoutTopbarMenuList: LayoutTopbarMenu[] = [];
  showMenu: boolean;
  expressFlagList = new Flags<ExpressMerchandiseFlags>();
  expressFlagListEnum = ExpressMerchandiseFlags;
  loginActions: Actions<LoginSharedActions, any> = new Actions<LoginSharedActions, any>();
  showSignIn: boolean;
  destroyEventFn: () => void;

  constructor(
    private userDataService: UserDataService,
    private router: Router,
    private permissionService: PermissionService,
    private render: Renderer2
  ) {
    /** */
  }

  async ngOnInit(): Promise<void> {
    await this.getUserData();
    this.watchMenu();

    this.destroyEventFn = this.render.listen('window', 'click', (e: Event) => {
      if (!this.topbar.nativeElement.contains(e.target)) {
        this.showMenu = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyEventFn();
  }

  /**
   * get user data
   */
  async getUserData(): Promise<void> {
    this.userData = await this.userDataService.getUserDataAsPromise();
    this.loadTopBarMenu();
  }

  /**
   * toggle menu
   */
  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  /**
   * Load option of topbar menu
   */
  async loadTopBarMenu(): Promise<void> {
    if (this.userData?.status < 0) {
      this.showSignIn = true;
    }
    if (await this.permissionService.canAccess(PermissionProfileOption.PROFILE_COMMON_LOGIN)) {
      const itemProfile: LayoutTopbarMenu = {
        label: 'topbar.profile',
        icon: 'mu-icon-user',
        action: LayoutMenuActions.PROFILE,
      };
      this.layoutTopbarMenuList.push(itemProfile);
    }
    if (
      (await this.permissionService.canAccess(PermissionUserOption.USER_COMMON_LOGIN)) &&
      (await this.permissionService.canAccess(PermissionUserOption.USER_LIST))
    ) {
      const itemUsers: LayoutTopbarMenu = {
        label: 'topbar.users',
        icon: 'mu-icon-users',
        action: LayoutMenuActions.USERS,
      };
      this.layoutTopbarMenuList.push(itemUsers);
    }

    const itemSignout: LayoutTopbarMenu = {
      label: 'topbar.signout',
      icon: 'mu-icon-signout',
      action: LayoutMenuActions.SIGN_OUT,
    };
    this.layoutTopbarMenuList.push(itemSignout);
  }

  /**
   * Watch action to menu
   */
  watchMenu(): void {
    this.loginActionsMenu.on(LayoutMenuActions.PROFILE, () => {
      this.router.navigate(['mi-perfil/informacion-basica']);
    });

    this.loginActionsMenu.on(LayoutMenuActions.USERS, () => {
      this.router.navigate(['usuarios/lista']);
    });

    this.loginActionsMenu.on(LayoutMenuActions.SIGN_OUT, () => {
      this.actionList.emit(this.actionListEnum.SIGN_OUT, null);
    });

    this.loginActions.on(LoginSharedActions.SUCESS, async (_, user: UserData) => {
      window.location.reload();
    });
  }
}
